/**
 * Minimal functional CSS required for the library to work.
 * Injected automatically - no external CSS file needed.
 */
export const FUNCTIONAL_CSS = `
.fbn-ic-gallery {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  perspective: 1000px;
}

.fbn-ic-image {
  position: absolute;
  cursor: pointer;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.6s cubic-bezier(0.4, 0, 0.2, 1),
    filter 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    border 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    outline 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    z-index 0s 0.6s;
  will-change: transform;
  user-select: none;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

.fbn-ic-image.fbn-ic-focused {
  z-index: 1000;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.6s cubic-bezier(0.4, 0, 0.2, 1),
    filter 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    border 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    outline 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    z-index 0s 0s;
  will-change: auto;
}

.fbn-ic-counter {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10001;
  pointer-events: none;
}

.fbn-ic-gallery:focus,
.fbn-ic-gallery.fbn-ic-has-focus {
  outline: 2px solid rgba(147, 197, 253, 0.8);
  outline-offset: -4px;
}
.fbn-ic-gallery.fbn-ic-suppress-outline:focus {
  outline: none;
}
.fbn-ic-gallery.fbn-ic-suppress-outline.fbn-ic-has-focus {
  outline: 2px solid rgba(99, 102, 241, 0.6);
  outline-offset: -4px;
}

.fbn-ic-nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10001;
  cursor: pointer;
  border: none;
  background: none;
  padding: 0;
  line-height: 1;
}
.fbn-ic-nav-btn-prev {
  left: 12px;
}
.fbn-ic-nav-btn-next {
  right: 12px;
}

.fbn-ic-hidden {
  display: none !important;
}
`;

/**
 * Inject functional styles into document head.
 * Idempotent - safe to call multiple times.
 */
export function injectFunctionalStyles(): void {
  if (typeof document === 'undefined') return;
  const id = 'fbn-ic-functional-styles';
  if (document.getElementById(id)) return;
  const style = document.createElement('style');
  style.id = id;
  style.textContent = FUNCTIONAL_CSS;
  document.head.appendChild(style);
}
